<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>箱码查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运单号" prop="freight_bill_code">
                <el-input v-model.trim="searchform.freight_bill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batch_no">
                <el-input v-model.trim="searchform.batch_no" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库单号" prop="out_bill_code">
                <el-input v-model.trim="searchform.out_bill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="产品编码" prop="product_code">
                <el-select
                  v-model="searchform.product_code"
                  placeholder="请输入产品名称模糊匹配或者下拉选择"
                  style="width:100%"
                  :remote-method="getproductlist"
                  filterable
                  remote
                  :loading="productloading"
                  :disabled="show"
                >
                  <el-option
                    v-for="item in productlist"
                    :key="item.product_code"
                    :label="item.product"
                    :value="item.product_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="箱码" prop="qrcode">
                <el-input v-model.trim="searchform.qrcode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['boxcode_select']"
              >搜索</el-button>
              <el-button
                v-permission="['boxcode_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>箱码查询</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column
              prop="freight_bill_code"
              label="运单号"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="out_bill_code"
              label="出库单号"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>

            <el-table-column
              prop="from_warehouse"
              label="发货仓库"
              min-width="120"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="dealer_name" label="客户" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品" min-width="300" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="箱码" min-width="170" show-overflow-tooltip></el-table-column>
            <el-table-column prop="packageLevel" label="包装级别" min-width="170" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batch_no" label="出库批次" min-width="100" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { selectoutbillorderqrcode } from "@/api/physical";
import { productlist } from "@/api/base";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.open();
    this.getproductlist();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      channelType: [
        {
          value: 0,
          label: "配送中心"
        },
        {
          value: 1,
          label: "退货仓"
        }
      ],
      packageLevel: [
        {
          value: 1,
          label: "盒"
        },
        {
          value: 2,
          label: "箱"
        }
      ],
      searchform: {
        batch_no: null,
        freight_bill_code: null,
        out_bill_code: null,
        datelist: [], // 接收时间数组，暂不调用
        qrcode: null,
        product_code: null,
        currPage: 1,
        pageSize: 10
      },
      productloading: false,
      show: false,
      productlist: [] //产品列表下拉
    };
  },
  methods: {
    // 获取产品下拉
      getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      if (
        this.searchform.batch_no ||
        this.searchform.freight_bill_code ||
        this.searchform.out_bill_code ||
        this.searchform.qrcode ||
        this.searchform.product_code
      ) {
        this.listLoading = true;
        selectoutbillorderqrcode(obj).then(response => {
          this.tableData = response.data.list;
          this.packdate(this.tableData);
          this.currentPage = response.data.currPage;
          this.total_count = response.data.totalCount;
          this.listLoading = false;
          console.log(this.tableData);
        });
      } else {
        this.$message({
          type: "warning",
          message: "请输入搜索条件"
        });
      }
    },
    // 拼装列表数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].scan_time = this.$parseTime(obj[i].scan_time);
        obj[i].from_warehouse =
          (obj[i].from_warehouse_code || " ") + (obj[i].from_warehouse || " ");
        obj[i].dealer_name =
          (obj[i].dealer_code || " ") + (obj[i].dealer_name || " ");
        obj[i].product =
          (obj[i].product_code || " ") + (obj[i].product_name || " ");
        switch (obj[i].status) {
          case 0:
            obj[i].status = "未发货";
            break;
          case 1:
            obj[i].status = "已发货";
            break;
          case 2:
            obj[i].status = "已签收";
            break;
          default:
            break;
        }
        switch (obj[i].packageLevel) {
          case 1:
            obj[i].packageLevel = "一级包装";
            break;
          case 2:
            obj[i].packageLevel = "二级包装";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        batch_no: this.searchform.batch_no,
        freight_bill_code: this.searchform.freight_bill_code,
        out_bill_code: this.searchform.out_bill_code,
        qrcode: this.searchform.qrcode,
        product_code: this.searchform.product_code,
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        batch_no: this.searchform.batch_no,
        freight_bill_code: this.searchform.freight_bill_code,
        out_bill_code: this.searchform.out_bill_code,
        qrcode: this.searchform.qrcode,
        product_code: this.searchform.product_code,
        currPage: this.searchform.currPage,
        pageSize: this.searchform.pageSize
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    // 载入提示
    open() {
      const h = this.$createElement;
      this.searchform.freight_bill_code = this.$route.query.freight_bill_code;
      this.search();
      // this.$notify({
      //   title: "页面提示",
      //   message: h("i", "数据量较大，请输入搜索条件进行筛选")
      // });
    },
    //导出表格事件
    handleDownload() {
      if (
        this.searchform.batch_no ||
        this.searchform.freight_bill_code ||
        this.searchform.out_bill_code ||
        this.searchform.qrcode ||
        this.searchform.product_code
      ) {
        this.downloadLoading = true;
        const obj = {
          page_index: 1,
          pageSize: this.total_count,
          batch_no: this.searchform.batch_no,
          freight_bill_code: this.searchform.freight_bill_code,
          out_bill_code: this.searchform.out_bill_code,
          qrcode: this.searchform.qrcode,
          product_code: this.searchform.product_code
        };
        selectoutbillorderqrcode(obj).then(response => {
          this.tableDataDownload = response.data.list;
          this.packdate(this.tableDataDownload);
          this.total_count = response.data.totalCount;
          this.currentPage = response.data.currPage;
          console.log(this.tableDataDownload);
          import("@/vendor/Export2Excel").then(excel => {
            const tHeader = [
              "运单号",
              "出库单号",
              "发货仓库",
              "客户",
              "产品",
              "箱码",
              "包装级别",
              "出库批次"
            ];
            const filterVal = [
              "freight_bill_code",
              "out_bill_code",
              "from_warehouse",
              "dealer_name",
              "product",
              "qrcode",
              "packageLevel",
              "batch_no"
            ];
            const list = this.tableDataDownload;
            const data = this.formatJson(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: this.filename,
              autoWidth: this.autoWidth,
              bookType: this.bookType
            });
            this.downloadLoading = false;
          });
        }); // hear
      } else {
        this.$message({
          type: "warning",
          message: "请输入搜索条件"
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>